import { render, staticRenderFns } from "./EnterNewPersonalEvent.vue?vue&type=template&id=1f64bbce"
import script from "./EnterNewPersonalEvent.vue?vue&type=script&lang=js"
export * from "./EnterNewPersonalEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports